import { useLocation } from 'react-router-dom';
import { useCallback, useEffect, useRef } from 'react';

export const useAbortController = () => {
    const location = useLocation();
    const currentControllerRef = useRef(new AbortController());

    // Abort the current controller & Create a new controller
    const abortAndRenew = useCallback(() => {
        currentControllerRef.current.abort();
        currentControllerRef.current = new AbortController();
    }, []);

    useEffect(() => {
        abortAndRenew();

        return () => {
            // Clean up function
            currentControllerRef.current.abort();
        };
    }, [location.pathname, abortAndRenew]);

    return {
        getCurrentController: () => currentControllerRef.current,
        abortAndRenew,
    };
};
